import * as Actions from '../constants/actions';
import { toast } from 'react-toastify';
import * as request from 'superagent';
import * as GroupActions from '../actions/group';
import * as StoryActions from '../actions/story';

			
export const ajaxMiddleware = store => next => action => {
	console.log('ACTITYPE', action.type);
	switch ( action.type ) {
		case(Actions.USER_LOGIN):
			request.post('/user/login')
			.send({username: action.payload.username, password: action.payload.password})
			.set('accept', 'json')
			.end((err, res) => {
				if (err) {
					toast.error('Väärä käyttäjänimi tai salasana');
				} else {
					localStorage.setItem('token', 'Bearer ' + res.body.token);
					store.dispatch(GroupActions.setGroups(res.body.groups));
					store.dispatch(StoryActions.setStories(res.body.stories));
					action.payload = res.body.user;
					next(action);
				}
			});
			break;

		case(Actions.USER_AUTHENTICATE):
			request
			.get('/user/authenticate')
			.set('Authorization', localStorage.getItem('token'))
			.end((err, res) => {
				if (err) {
					console.log(res.text);
				} else {
					console.log("AUTHENTICATION SUCCESSFULL");
					store.dispatch(GroupActions.setGroups(res.body.groups));
					store.dispatch(StoryActions.setStories(res.body.stories));
					action.payload = res.body.user;
					next(action);
				}
			});
			break;

		case(Actions.USER_REGISTER):
			const newUser = {
				username: action.payload.user.username,
				password: action.payload.user.password, 
				firstname: action.payload.user.firstname, 
				lastname: action.payload.user.lastname,
				school: action.payload.user.school
			};

			request.post('/user/register')
			.send({user: newUser, code: action.payload.code.toUpperCase() })
			.set('accept', 'json')
			.end((err, res) => {
				if (err) {
					toast.error(res.text);
				} else {
					localStorage.setItem('token', 'Bearer ' + res.body.token);
					action.payload = res.body.user;
					next(action);
				}
			});
			break;

		case(Actions.USER_UPDATE):
			console.log('block');
			request
                .post('/user/update')        
                .set('Content-Type', 'application/json')
				.set('Authorization', localStorage.getItem('token'))
                .send(action.payload)
                .then((response) => {
					delete action.payload.password;
					toast.success('Tietojen muuttaminen onnistui.');
					next(action);
                })   
                .catch((err) => {
                    toast.error(err);
                }) 
			break;

		case(Actions.STUDENT_LOGIN):
			request.post('/student/login')
			.send(action.payload)
			.set('accept', 'json')
			.end((err, res) => {
				if (err) {
					toast.error(res.text);
				} else {
					localStorage.setItem('studenttoken', 'Bearer ' + res.body.token);
					action.payload = res.body.student;
					store.dispatch(GroupActions.setGroups([{campaigns: res.body.campaigns, _id: '1', name: 'studGrp', students: [res.body.student], owners: []}]));
					store.dispatch(StoryActions.setStories(res.body.stories));
					next(action);
				}
			});

			break;
		case(Actions.STUDENT_AUTHENTICATE):
			request.post('/student/authenticate')
			.set('Authorization', localStorage.getItem('studenttoken'))
			.end((err, res) => {
				if (err) {
					console.log(res.text);
				} else {
					store.dispatch(GroupActions.setGroups([{campaigns: res.body.campaigns, _id: '1', name: 'studGrp', students: [res.body.student], owners: []}]));
					store.dispatch(StoryActions.setStories(res.body.stories));
					action.payload = res.body.student;
					next(action);
				}
			});
			break;
		case(Actions.STORY_ADD):
			
			console.log("ADDING STORY", action.payload);

			if (!action.payload.audio) {
				request.post('/story/add')
				.field('info', JSON.stringify(action.payload.info))
				.field('positions', JSON.stringify(action.payload.positions))
				.field('zoomHistory', JSON.stringify(action.payload.zoomHistory))
				.set('Authorization', localStorage.getItem('studenttoken'))
				.end((err, res) => {
					if (err) {
						toast.error(res.text);
					} else {
						next(action);
					}
				});
			} else {
				request.post('/story/add')
				.attach('audio', action.payload.audio)
				.field('info', JSON.stringify(action.payload.info))
				.field('positions', JSON.stringify(action.payload.positions))
				.field('zoomHistory', JSON.stringify(action.payload.zoomHistory))
				.set('Authorization', localStorage.getItem('studenttoken'))
				.end((err, res) => {
					if (err) {
						toast.error(res.text);
					} else {
						toast.success("Tarina tallennettu");
						next(action);
					}
				});
			}
			break;

		case(Actions.STORY_DELETE):
			request.delete('/story')
			.send(action.payload)
			.set('Authorization', localStorage.getItem('token') || localStorage.getItem('studenttoken'))
			.end((err, res) => {
				if(err) {
					toast.error(res.text);
				} else {
					next(action);
				}
			});
			break;

		case(Actions.STORY_MARK_IMPORTANT):
		case(Actions.STORY_MARK_GRADED):	
			request.put('/story')
			.send(action.payload)
			.set('Authorization', localStorage.getItem('token'))
			.end((err, res) => {
				if(err) {
					toast.error(res.text);
				} else {
					next(action);
				}
			});
			break;

		default:
			console.log("SKIPPING AJAX ", action.type)
			next(action);
			break;
	}
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/ajaxmiddleware.ts